<section class="d-flex flex-column h-full-header overflow-hidden">
  <div class="d-flex flex-wrap align-items-center p-1 mb-1 border-bottom compact-controls sticky white-bg">
    <div class="ml-1">
      <input type="text" placeholder="جستجو" name="keyword" [(ngModel)]="criteria.Keyword" (debounce)="load(0)" />
    </div>
    <div class="ml-1">
      <select [(ngModel)]="criteria.Type" (change)="load(0)">
        <option [ngValue]="undefined">نوع</option>
        <option [ngValue]="'-not-set'">ست نشده</option>
        <option [ngValue]="'-set'">ست شده</option>
        <option [ngValue]="type.Key" *ngFor="let type of types">{{type.Key|readable:'resourceType'}} ({{type.DocCount}})
        </option>
      </select>
    </div>
    <div class="ml-1">
      <select [(ngModel)]="criteria.Source" (change)="load(0)">
        <option [ngValue]="undefined">منبع</option>
        <option [ngValue]="source.Key" *ngFor="let source of sources">{{source.Key}} ({{source.DocCount|number}})</option>
      </select>
    </div>
    <div class="ml-1">
      <select [(ngModel)]="criteria.IsReady" (change)="load(0)">
        <option [ngValue]="undefined">کامل بودن</option>
        <option [ngValue]="true">کامل</option>
        <option [ngValue]="false">ناقص</option>
      </select>
    </div>
    <div class="ml-1">
      <select [(ngModel)]="criteria.HasDescription" (change)="load(0)">
        <option [ngValue]="undefined">وجود توضیحات</option>
        <option [ngValue]="true">توضیحات دارد</option>
        <option [ngValue]="false">توضیحات ندارد</option>
      </select>
    </div>
    <div class="ml-1">
      <select [(ngModel)]="criteria.Status" (change)="load(0)">
        <option [ngValue]="undefined">وضعیت</option>
        <option [ngValue]="ResourceStatus.Pending">{{ResourceStatus.Pending|readable:'resourceStatus'}}</option>
        <option [ngValue]="ResourceStatus.Published">{{ResourceStatus.Published|readable:'resourceStatus'}}</option>
        <option [ngValue]="ResourceStatus.Rejected">{{ResourceStatus.Rejected|readable:'resourceStatus'}}</option>
        <option [ngValue]="ResourceStatus.Paused">{{ResourceStatus.Paused|readable:'resourceStatus'}}</option>
        <option [ngValue]="ResourceStatus.Finished">{{ResourceStatus.Finished|readable:'resourceStatus'}}</option>
        <option [ngValue]="ResourceStatus.Archived">{{ResourceStatus.Archived|readable:'resourceStatus'}}</option>
      </select>
    </div>
    <div class="ml-1">
      <ng-select [(ngModel)]="criteria.Tags" [addTag]="false" [items]="tags" [multiple]="true" [selectOnTab]="true"
        bindLabel="Key" bindValue="Key" (ngModelChange)="load(0)">
        <ng-template ng-option-tmp let-item="item">
          {{item.Key}} ({{item.DocCount}})
        </ng-template>
      </ng-select>
    </div>
    <div class="ml-1">
      <button type="button" class="btn btn-secondary btn-sm fs-sm" (click)="load(0)">جستجو</button>
    </div>
    <div class="mx-auto"></div>
    <div class="ml-1">
      {{total|number}}
    </div>
    <div class="ml-1">
      <select [(ngModel)]="limit" (change)="load(0)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
        <option [ngValue]="500">500</option>
        <option [ngValue]="1000">1000</option>
      </select>
    </div>
    <div class="ml-1">
      <select [(ngModel)]="criteria.Sort" (change)="load(0)">
        <option value="UpdateTime">بروزرسانی</option>
        <option value="RegisterTime">ثبت</option>
        <option value="Impression">بازدید</option>
        <option value="_score">امتیاز جستجو</option>
      </select>
    </div>
    <button (click)="openModal()" class="btn btn-sm btn-primary">ایجاد</button>
  </div>
  <div class="d-flex flex-grow-1 overflow-hidden">
    <div class="container-capped-xs px-0 ml-2 border-left h-100 overflow-auto">
      <ng-container *ngIf="aggs">
        <ng-container *ngTemplateOutlet="filterTemplate;context:{title: 'وضعیت', agg:'statuses', crit: 'Status'}"></ng-container>
        <ng-container *ngTemplateOutlet="filterTemplate;context:{title: 'نوع', agg:'types', crit: 'Type'}"></ng-container>
        <ng-container *ngTemplateOutlet="filterTemplate;context:{title: 'منبع', agg:'sources', crit: 'Source'}"></ng-container>
        <ng-container *ngTemplateOutlet="filterTemplate;context:{title: 'تگ', agg:'tags', crit: 'Tag'}"></ng-container>
  
      </ng-container>
  
    </div>
    <div class="container px-0 x-light-gray-bg d-flex flex-column gap-1  h-100 overflow-auto">
      <div class="d-flex align-items-center sticky white-bg">
        <div class="ml-1">
          <input type="checkbox" name="toggle-select" (change)="toggleSelectAll($event.target.checked)">
        </div>
        <div class="ml-1">
          <i class="fa fa-file-csv pointer f-blue" (click)="exportModal.open()"></i>
        </div>
        <div class="ml-1 d-flex align-items-center ">
          <div>
            <select [(ngModel)]="updatdeType">
              <option [ngValue]="null">نوع</option>
              <option [ngValue]="type.Key" *ngFor="let type of types">{{type.Key|readable:'resourceType'}} </option>
            </select>
          </div>
          <button type="button" class="btn btn-secondary btn-sm fs-sm mr-1" [disabled]="updatdeType==null"
            (confirm)="bulkUpdate({Type:updatdeType})">ست کردن نوع</button>
        </div>
        <div class="ml-1 d-flex align-items-center">
          <div>
            <select [(ngModel)]="updatdeStatus">
              <option [ngValue]="null">وضعیت</option>
              <option [ngValue]="ResourceStatus.Pending">{{ResourceStatus.Pending|readable:'resourceStatus'}}</option>
              <option [ngValue]="ResourceStatus.Published">{{ResourceStatus.Published|readable:'resourceStatus'}}
              </option>
              <option [ngValue]="ResourceStatus.Rejected">{{ResourceStatus.Rejected|readable:'resourceStatus'}}</option>
              <option [ngValue]="ResourceStatus.Paused">{{ResourceStatus.Paused|readable:'resourceStatus'}}</option>
              <option [ngValue]="ResourceStatus.Finished">{{ResourceStatus.Finished|readable:'resourceStatus'}}</option>
              <option [ngValue]="ResourceStatus.Archived">{{ResourceStatus.Archived|readable:'resourceStatus'}}</option>
            </select>
          </div>
          <button type="button" class="btn btn-secondary btn-sm fs-sm mr-1" [disabled]="updatdeStatus==null"
            (confirm)="bulkUpdate({Status:updatdeStatus})">ست کردن وضعیت</button>
        </div>
        <div class="ml-1">
          <button type="button" class="btn btn-secondary btn-sm fs-sm mr-1" (confirm)="reindex()">ایندکس</button>
        </div>
        <div class="mr-auto">
          <app-pagination [total]="total" [limit]="limit"></app-pagination>
        </div>
      </div>
      <resource-detail *ngFor="let resource of resources" [resource]="resource" [mode]="'list'"
        [selected]="resource._selected || resource.Id==selected?.Id">
        <div toolbar>
          <div class="d-flex align-items-center mb-1 border-bottom">
            <input class="ml-auto" type="checkbox" [(ngModel)]="resource._selected" />
            <a *ngIf="resource.IsIndexed" target="_blank" [href]="resource.Source?.Url"
              [title]="resource.Source?.Title">
              <i class="fa fa-external-link-alt mx-1 pointer"></i>
            </a>
            <span class="badge badge-pill light-gray-bg mx-1">{{resource.Status|readable:'resourceStatus'}}</span>
            <span class="badge badge-pill x-light-gray-bg mx-1" *ngIf="resource.RegisterTime">ثبت:
              {{resource.RegisterTime|pdate}}</span>
            <span class="badge badge-pill x-light-gray-bg mx-1" *ngIf="resource.UpdateTime">بروزرسانی:
              {{resource.UpdateTime|pdate}}</span>
            <span class="badge badge-pill x-light-gray-bg mx-1" *ngIf="resource.Impression">بازدید:
              {{resource.Impression|number}}</span>
            <span class="badge badge-pill x-light-gray-bg mx-1" *ngIf="resource.SourceImpression">بازدید منبع:
              {{resource.SourceImpression|number}}</span>
            <i class="fa fa-edit mx-1 pointer" (click)="openModal(resource)"></i>
          </div>
        </div>
      </resource-detail>
    </div>
  </div>
</section>

<ngx-smart-modal #resourceModal identifier="resourceModal" customClass="full-width">
  <div *ngIf="resourceModal.visible && selected">
    <admin-edit-resource [resource]="selected" (saved)="onSave($event);"></admin-edit-resource>
  </div>
</ngx-smart-modal>
<ngx-smart-modal #exportModal identifier="exportModal" customClass="full-width">
  <div *ngIf="exportModal.visible">
    <pre copy dir="ltr" class="text-left overflow-auto w-100 p-1 border rounded">
Id,Title,Url
<ng-container *ngFor="let item of resources|filter:{_selected:true}">{{item.Id}},{{item.Title}},{{item.Source?.Url}}{{'\n'}}</ng-container>
    </pre>
  </div>
</ngx-smart-modal>
<ng-template #filterTemplate let-title="title" let-agg="agg" let-crit="crit">
  <div *ngIf="aggs[agg]?.length > 0" class="mb-1 pb-1 px-2 border-bottom">
    <h6>{{title}}</h6>
    <div class="d-flex align-items-center justify-content-between mb-1 pointer " *ngFor="let item of aggs[agg]"
      [class.fw-bold]="item.Key == criteria[crit]"
      (click)="(item.Key == criteria[crit] ? criteria[crit]=undefined : criteria[crit]=item.Key);load(0)">
      <span>{{item.Key}}</span>({{item.DocCount}})
    </div>

  </div>

</ng-template>